import React from 'react'
import { TooltipWrapper } from '@winnin/winnin_ui.components.tooltip-wrapper'
import './index.scss'

export default function TabsToggle({ tabs, activeTab, onClick }) {
  return (
    <div className="TabsWrapper-content-tabs">
      {tabs.map(tab => {
        if (tab?.isBlocked) {
          return (
            <TooltipWrapper
              key={tab.value}
              isTooltipMultiline
              tooltipStyle="tooltippedS"
              tooltipMessage={tab?.blockedTabMessage}
            >
              <div className="TabsWrapper-content-tabs-tab">{tab.name}</div>
            </TooltipWrapper>
          )
        }
        return (
          <div key={tab.value}>
            <button
              className={`TabsWrapper-content-tabs-tab${tab.value === activeTab ? '-active' : ''}`}
              onClick={() => {
                onClick(tab.value)
              }}
            >
              {tab.name}
            </button>
          </div>
        )
      })}
    </div>
  )
}
